import { MediaMatcher } from "@angular/cdk/layout";
import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MatSidenav } from "@angular/material/sidenav";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { name, version } from "package.json";
import { filter, switchMap } from "rxjs/operators";
import { AuthenticationService } from "../../services/authentication/authentication.service";
import { LayoutService } from "../../services/layouts/layout.service";
import { Translator } from "../../services/translator/translator.service";
import { of, Subscription } from "rxjs";

/** Altura do footer em px - mantener sincronizado con home-layout.component.scss */
const FOOTER_HEIGHT = 48;

@Component({
  selector: "app-home-layout",
  templateUrl: "./home-layout.component.html",
  styleUrls: ["./home-layout.component.scss"],
})
export class HomeLayoutComponent implements OnInit, AfterViewInit, OnDestroy {
  readonly footerHeight = FOOTER_HEIGHT;
  mobileQuery: MediaQueryList;
  media: MediaMatcher;
  private _mobileQueryListener: () => void;
  changeDetectorRef: ChangeDetectorRef;

  opened: boolean = true;
  sectionTitle: string = "";
  currentYear: Date;
  translation: any;
  public version: string = version;
  public appname: string = name;

  @ViewChild("sidenav") mysidenav: MatSidenav;
  private openedChangeSub: Subscription;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private router: Router,
    private autentificador: AuthenticationService,
    private _ruta: ActivatedRoute,
    private translator: Translator,
    private _layoutservices: LayoutService
  ) {
    this.changeDetectorRef = changeDetectorRef;
    this.media = media;
    this.currentYear = new Date();
  }

  initConfig() {
    if (this._ruta.firstChild)
      this.router.events
        .pipe(
          filter((event) => event instanceof NavigationEnd),
          switchMap(() => this._ruta.firstChild.data)
        )
        .subscribe((data) => {
          if (data && data && data.SectionTitle) {
            this.sectionTitle = this.translation[data.SectionTitle];
          }
        });
  }

  async initializeTranslate() {
    this.translation = this.translator.GetTranslations();
  }

  ngOnInit() {
    this.initializeTranslate();
    this.initConfig();
    this.initRouterEvents();
    this.mobileQuery = this.media.matchMedia("(max-width: 600px)");
    this._mobileQueryListener = () => {
      if (this.mobileQuery.matches) {
        this._layoutservices.sidebar_opened.emit(false);
        this.mysidenav.close();
        this.opened = false;
      } else {
        this._layoutservices.sidebar_opened.emit(true);
        this.mysidenav.open();
        this.opened = true;
      }
      this.syncSidenavLayout();
    };
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngAfterViewInit(): void {
    if (this.mysidenav) {
      this.opened = this.mysidenav.opened;
      this.openedChangeSub = this.mysidenav.openedChange.subscribe((opened: boolean) => {
        this.opened = opened;
        this.changeDetectorRef.detectChanges();
      });
    }
  }

  ngOnDestroy(): void {
    this.mobileQuery?.removeListener?.(this._mobileQueryListener);
    this.openedChangeSub?.unsubscribe();
  }

  private initRouterEvents(): void {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        switchMap(() => (this._ruta.firstChild?.data ?? of({})))
      )
      .subscribe((data) => {
        if (data && data.SectionTitle) {
          this.sectionTitle = this.translation[data.SectionTitle];
        }
      });
  }

  menutoogle() {
    if (this.mysidenav.opened) {
      this._layoutservices.sidebar_opened.emit(false);
      this.mysidenav.close();
      this.opened = false;
    } else {
      this._layoutservices.sidebar_opened.emit(true);
      this.mysidenav.open();
      this.opened = true;
    }
    this.syncSidenavLayout();
  }
  sidenavClose() {
    this.mysidenav.close();
    this.opened = false;
    this._layoutservices.sidebar_opened.emit(false);
    this.syncSidenavLayout();
  }
  logout() {
    this.autentificador.logout();
  }

  toTop() {
    document.getElementById("eltope").scrollTop = 0;
  }

  private syncSidenavLayout() {
    setTimeout(() => {
      const container = (this.mysidenav as any)?._container;
      if (container && typeof container.updateContentMargins === "function") {
        container.updateContentMargins();
      }
      window.dispatchEvent(new Event("resize"));
      this.changeDetectorRef.detectChanges();
    }, 250);
  }
}
